import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import img20 from './image/logo.png';

import img1 from './image/img1.png';
import img2 from './image/img2.jpg';
import img3 from './image/img3.webp';
import img4 from './image/img4.jpg';
import img6 from './image/img6.jpg';
import img7 from './image/img7.jpg';
import img8 from './image/img8.jpg';
import img9 from './image/img9.jpg';
import img10 from './image/img10.jpg';
import img11 from './image/img11.jpg';
import img12 from './image/img12.jpg';
import img13 from './image/img13.jpg';
import img14 from './image/img14.jpg';
import img15 from './image/img15.jpg';
import img16 from './image/img16.jpg';
import img17 from './image/img17.jpg';
import img18 from './image/img18.jpg';
import img19 from './image/img19.jpg';
import img22 from './image/img20.jpg';
import img21 from './image/img21.png';
import img23 from './image/img23.png';
import img24 from './image/img24.png';
import img25 from './image/img25.png';


// Header Component
export const Header = ({ isMenuOpen, setIsMenuOpen }) => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navigation = [
    { name: "Home", href: "/" },
    
    {
      name: "Services",
      href: "/services",
      children: [
        { name: "Laser Hair Reduction", href: "/service/1" },
        { name: "BB Glow Treatment", href: "/service/0" },
        { name: "Hydra Facial", href: "/service/2" },
        { name: "Derma-Pen / Micro-Needling", href: "/service/3" },
        { name: "Face Tightening RF Facial", href: "/service/4" },
        { name: "Hair PRP Treatment", href: "/service/5" },
        { name: "Hair GFC Therapy", href: "/service/6" },
        { name: "Body Polishing", href: "/service/7" },

        { name: "Chemical Peels", href: "/service/8" },
        { name: "Body Lightening Treatments", href: "/service/9" },
        { name: "DARK CIRCLES", href: "/service/11" },
        { name: "DARK UNDERARMS", href: "/service/12" },
        { name: "Melasma", href: "/service/13" },
        { name: "⁠PRP HAIR TREATMENT", href: "/service/14" },
        { name: "⁠TATTOO REMOVAL", href: "/service/15" },
        { name: "⁠MAKE OVER", href: "/service/16" },
        { name: "⁠SKIN MAINTAINANCE", href: "/service/17" },
      ],
    },
    { name: "Review", href: "/review" },
    { name: "About Us", href: "/about" },
    { name: "Contact Us", href: "/contact" },
  ];

  return (
    <header className={`header ${scrolled ? "scrolled" : ""}`}>
      <span className="nav-email">
       <a href='tel:8595525386'>📱tel-8595525386</a>
      <a href="mailto:dermavisiondwarka@gmail.com">📤dermavisiondwarka@gmail.com</a>
       <span className="nav-inst">
       <a  href="https://www.instagram.com/dermavision_?igsh=azRiZmhpbXFidGg3" alt="Instagram, @dermavision_">@dermavision_</a>
       </span>
      </span>
      <nav className="nav-container">
        <div className="nav-content">
          <Link to="/" className="logo">
          <img src={img20} alt="dermavsion" className="logo-img" />
            <span className="logo-text"> Dermavision</span>
          </Link>

          <div className="nav-links desktop-nav">
            {navigation.map((item) => (
              <div key={item.name} className="nav-item">
                <Link
                  to={item.href}
                  className={`nav-link ${
                    location.pathname === item.href ? "active" : ""
                  }`}
                >
                  {item.name}
                </Link>
                {item.children && (
                  <div className="dropdown">
                    {item.children.map((child) => (
                      <Link
                        key={child.name}
                        to={child.href}
                        className="dropdown-link"
                      >
                        {child.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="nav-actions">
            <Link to="/contact" className="btn">
              <button className="cta-button  " alt="APPOINTMENT">APPOINTMENT</button>
            </Link>
            
            <button
              className="mobile-menu-toggle " alt="Menu-toggle"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${isMenuOpen ? "open" : ""}`}>
          <div className="mobile-menu-content">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`mobile-nav-link ${
                  location.pathname === item.href ? "active" : ""
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <Link to="/contact" className="btn">
              <button className="cta-button primary">Book A Call</button>
            </Link>
          </div>
        </div>
      </nav>

      {/* ✅ Floating Call Button */}
      <a href="tel:8595525386" className="call-button" alt="phone-number">
       <span>📞</span>  Call  Us
      </a>
      <a href="https://wa.me/8130525386" className="Whats-button" target="_blank" rel="noopener noreferrer" alt="whatsapp-number" > 
      <span>💬</span>Whats App Us </a>
    </header>
  );
};



// Footer Component
export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
           <div className="footer-section">
        <h3 className="footer-title">Find Us</h3>
        <div className="footer-map">
          <iframe title="Clinic Location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.3168449434943!2d77.05693242470835!3d28.560246875704195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1b6685d8affd%3A0x94de45284c469b11!2sManish%20Global%20Mall!5e0!3m2!1sen!2sin!4v1768316217320!5m2!1sen!2sin" width="100%" height="250" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" ></iframe>
        </div>
      </div>

          <div className="footer-section">
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/services" className="footer-link">Services</Link></li>
              <li><Link to="/features" className="footer-link">Features</Link></li>
              <li><Link to="/privacy-policy" className="footer-link">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions" className="footer-link">Terms and Conditions</Link></li>
              <li><Link to="/refund-and-cancellation-policy" className="footer-link">Refund and Cancellation Policy</Link></li>
          
              <li><Link to="/about" className="footer-link">About Us</Link></li>
              <li><Link to="/contact" className="footer-link">Contact Us</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Services</h3>
            <ul className="footer-links">
              <li><Link to="/service/1" className="footer-link">Laser Hair Removal</Link></li>
              <li><Link to="/service/0" className="footer-link">BB Glow Treatment</Link></li>
              <li><Link to="/service/3" className="footer-link">Micro-Needling</Link></li>
              <li><Link to="/service/4" className="footer-link">Face Tightening RF Facial</Link></li>
              <li><Link to="/service/5" className="footer-link">Hair PRP Treatment</Link></li>
              <li><Link to="/service/6" className="footer-link">Hair GFC Therapy</Link></li>
              <li><Link to="/service/7" className="footer-link">Body Polishing</Link></li>
              <li><Link to="/service/8" className="footer-link">Chemical Peels</Link></li>
              <li><Link to="/service/9" className="footer-link">Body Lightening Treatments</Link></li>
             
              <li><Link to="/service/10" className="footer-link">⁠Acne Treatment</Link></li>
              <li><Link to="/service/11" className="footer-link">DARK CIRCLES</Link></li>
              <li><Link to="/service/12" className="footer-link">DARK UNDERARMS</Link></li>
              

            </ul>
          </div>
          
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">© 2026 - All Cosmetologis & Health logos and trademarks displayed on this application are the property of their respective owners. </p>
            <p className="disclaimer" alt="description">We are a Cosmetologis & Health, dedicated to evidence‑based treatments and patient well‑being.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

 
 export const Review = () => {
  const testimonials = [
  { name: "Ayaan khan", role: "Hair Treatment", content: "I was struggling with hair thinning for years. The PRP therapy at Dermologis worked wonders. Professional staff and visible results — highly recommended.", rating: 5 },
  { name: "Shakshi Sharma", role: " Acne Carer", content: "After trying so many products, Dermologis was the only place that gave me lasting relief from acne. My skin feels healthier and clearer than ever", rating: 5 },
  { name: "Rajni Raj", role: "Anti‑Ageing Therapy", content: "The non‑surgical facelift was amazing. I look refreshed and natural, not overdone. Dermologis truly combines science with artistry.", rating: 5 },
   { name: "Aarav Malhotra", role: "Hair Restoration", content: "I had lost confidence due to severe hair fall. The advanced transplant procedure at Dermologis gave me natural-looking results. Truly life-changing experience.", rating: 5 }, 
  { name: "Sneha Kapoor", role: "Skin Rejuvenation", content: "My dull skin finally feels radiant again. The chemical peel treatment was safe, effective, and handled with great care by the team.", rating: 5 },
   { name: "Vikram Desai", role: "Scar Removal", content: "Years of acne scars faded significantly after laser therapy. The doctors explained every step and ensured I was comfortable throughout.", rating: 5 }
];

  return (
    <div className="testimonials-section">
      <h2 className="testimonials-title">What Our Clients Say</h2>
      <div className="testimonials-grid">
        {testimonials.map((testimonial, index) => (
          <div key={index} className="testimonial-card">
            <div className="testimonial-rating">
              {[...Array(testimonial.rating)].map((_, i) => (
                <span key={i} className="star">⭐</span>
              ))}
            </div>
            <p className="testimonial-content">"{testimonial.content}"</p>
            <div className="testimonial-author">
              <strong>{testimonial.name}</strong>
              <span>{testimonial.role}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};



// Services Page Componet
export const Services = () => { 
  // services
const cards = [
  { title: "BB Glow Treatment", text: "The BB Glow makeup that is done permanently is a semi-permanent clear up means that started in South Korea and it became famous all over the world because of its good power to give radiant, even-toned skin.", image: img1 },
  { title: "Laser Hair Reduction", text: "Laser hair reduction is a rebellious method for achieving smooth and hair free skin.Dermavision is your trusted partner for this advanced treatment. We are located in New Delhi, Dwarka sec-22", image: img2 },
  { title: "Hydra Facial", text: "A HydraFacial is a non-invasive skin treatment that deeply cleanses, exfoliates, extracts impurities, and hydrates the skin using advanced serums. It’s popular for delivering immediate glow, smoother texture, and reduced fine lines without downtime", image: img3 },
  { title: "Derma-Pen / Micro-Needling", text: "Micro Needling Treatment procedure, also known as percutaneous collagen induction therapy, is now called the cosmetic procedure to treat scars, enlarged pores, wrinkles, stretch marks and so on.", image: img4 },
  { title: "Face Tightening RF Facial", text: "A Radio Frequency (RF) Facial for face tightening is a non-surgical cosmetic treatment that uses radiofrequency energy to heat the deeper layers of the skin, stimulating collagen and elastin production. This helps reduce sagging, fine lines, and wrinkles, giving a firmer, more youthful look", image: img6 },
  { title: "Hair PRP Treatment", text: "When it comes to hair treatment procedures, we are your ultimate service provider in in west delhi region Dermavision ,where the quality of our work has exhibited the highest standards of care and expertise.", image: img7 },
  { title: "Hair GFC Therapy", text: "Hair GFC Therapy (Growth Factor Concentrate Therapy) is an advanced, non-surgical treatment for hair loss. It uses concentrated growth factors extracted from your own blood, which are then injected into the scalp to stimulate hair follicles, improve density, and reduce hair fall", image: img8 },
  { title: "Body Polishing", text: "Body Polishing is a professional skin treatment that exfoliates, hydrates, and rejuvenates the skin. It removes dead cells, improves circulation, reduces tanning, and leaves the skin smooth, radiant, and glowing", image: img9 },
  { title: "Chemical Peels", text: "A chemical peel is a dermatological treatment that uses a chemical solution to exfoliate the skin, remove damaged outer layers, and stimulate regeneration. It helps improve acne scars, pigmentation, fine lines, and overall skin texture", image: img10 },
  { title: "Body Lightening Treatments", text: "RF Skin Tighening, the abbreviation for Radiofrequency therapy, is a procedure which, of course, applies electromagnetic radiation to the patient’s body. The radiation heats the dermis of the skin and thus causes the collagen and elastin to reproduce themselves.", image: img11 },
  { title: "⁠Acne Treatment", text: "There are several types of acne scars, including atrophic scars (depressed or pitted scars), hypertrophic scars (raised scars), and keloid scars (thick and raised scars). Acne Treatment options for acne scarring depend on the type and severity of the scarring.", image: img12 },
  { title: "DARK CIRCLES", text: "Dark circles, also known as under-eye circles, are dark, discolored patches that appear underneath the eyes. They can be caused by a number of factors, including genetics, aging, lack of sleep, stress, allergies, dehydration, and medical conditions such as eczema or anemia.", image: img13 },
  { title: "DARK UNDERARMS", text: "Dark underarms are usually caused by skin conditions like acanthosis nigricans, friction, shaving, deodorants, or hormonal imbalances. They are often harmless but can sometimes signal underlying issues such as insulin resistance or obesity. Treatments include topical creams, exfoliation, laser therapy, and lifestyle changes", image: img14 },
  { title: "Melasma", text: "Melasma is the occurrence of skin hyperpigmentation. It shows itself through flat patches that are brown, blue-gray, or tan in color and occurs in the area of the cheeks, forehead, bridge of the nose, and the upper lip with predilection on these parts of the face", image: img15 },
  { title: "PRP HAIR TREATMENT", text: "PRP Hair Treatment (Platelet-Rich Plasma Therapy) is a non-surgical procedure that uses your own blood’s platelets to stimulate hair growth. It is widely used for treating hair thinning, androgenic alopecia (male/female pattern baldness), and improving hair density", image: img16 },
  { title: "TATTOO REMOVAL", text: "Removing a tattoo is a significant decision, and choosing the right clinic can make all the difference in your experience and results. Dermavision is a leading provider of tattoo removal services, known for our expertise, cutting-edge technology, and commitment to client satisfaction.", image: img17 },
  { title: "MAKE OVER", text: "A makeover can mean different things depending on what you’re aiming for—it could be a personal style transformation, a beauty treatment plan, or even a lifestyle upgrade. Let’s break it down so you can see the possibilities:", image: img19 },
  { title: "SKIN MAINTAINANCE", text: "At Dermavision we are committed to the client experience with the best quality and competence, thus making a beautiful, even, and smooth skin the reality of your life.", image: img18 },

  { title: "Cheek Tint", text: "Enhance your natural glow with a soft, radiant tint that gives your cheeks a youthful and even finish ,thus making a beautiful, even, and smooth skin the reality of your life.", image: img22,alt:"Cheek Tint Treatment in Dwarka, New Delhi" },
    { title: "Micro Blading", text: "Define and perfect your brows with precision strokes that mimic natural hair, creating fuller and beautifully shaped eyebrows.", image: img21,alt:"Micro blading Treatment in Dwarka, New Delhi" },
    { title: "Lip Tint", text: "Achieve naturally tinted lips with long-lasting color that enhances your smile while keeping your lips smooth and hydrated.", image: img23,alt:"Lip Tint Treatment in Dwarka, New Delhi" },
    { title: "tag Tint", text: "Safe and effective removal of skin tags for a clear, even complexion, restoring confidence in your skin’s appearance and smooth skin the reality of your life.", image: img24,alt:"tag Removal Treatment in Dwarka, New Delhi" },
    { title: "Mole Removal", text: "Expert mole removal treatments designed to leave your skin smooth and blemish-free, with minimal discomfort and maximum care.", image: img25,alt:"Mole Removel Treatment in Dwarka, New Delhi" }
  
];

  return ( 
  <section className="services"> 
  <div className="card-header"> <center> <span>What We Offer</span> </center> 
  <h1 className="features-header">Our Services</h1> 
  </div> <div className="card-container"> 
    {cards.map((card, index) => (
           <Link to={`/service/${index}`} key={index} className="card"> 
           <img src={card.image} alt={card.title} /> 
           <div className="card-content"> 
             <div className="card-title">{card.title}</div> 
             <div className="card-text">{card.text}</div> </div> 
             </Link>
            ))} 
      </div> </section> 
      ); 
    }; 
  
   


// Contact Page Component
export const Contact = () => {
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };


  const scriptURL = 'https://script.google.com/macros/s/AKfycbxS-1GvY1kKXizeieq0EjPaCQnfllnANHHZa45Lcb0Gi19xuAWhuQlXUkBxjeGmYa2UmA/exec';

const handleSubmit = (e) => {
  e.preventDefault();
  setIsLoading(true); // Show loader

  const formDataToSend = new FormData();
  formDataToSend.append('name', formData.name);
  formDataToSend.append('email', formData.email);
  formDataToSend.append('subject', formData.subject);
  formDataToSend.append('message', formData.message);

  fetch(scriptURL, { method: 'POST', body: formDataToSend })
    .then(response => {
      console.log('Success!', response);
      alert('Thank you for your message! We will get back to you soon.');
      setFormData({ name: '', email: '', subject: '', message: '' });
    })
    .catch(error => {
      console.error('Error!', error.message);
      alert('Oops! Something went wrong. Please try again later.');
    })
    .finally(() => {
      setIsLoading(false); // Hide loader
    });
};



  
  return (
    <div className="contact-page">
      <div className="container">
        <div className="contact-header">
          <h1 className="contact-title">Contact Us</h1>
          <p className="contact-subtitle">
            Get in touch with our team for any questions or support you need.
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <h2>Get in Touch</h2>
            <div className="contact-details">
              <div className="contact-item">
                <div className="contact-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                </div>
                <div className="contact-text">
                  <h3>Address</h3>
                  <p>S-24 second floor manish global mall, sector 22, dwarka delhi 110077</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <div className="contact-text">
                  <h3>Email</h3>
                  <p>dermavisiondwarka@gmail.com</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                </div>
                <div className="contact-text">
                  <h3>Phone</h3>
                  <p>+91 8595525386</p>
                  <p>+91 8130525386</p>

                </div>
              </div>
            </div>
          </div>

          <div className="contact-form">
            <h2>Send us a Message</h2>
            <form name="submit-to-google-sheet" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="subject">Number</label>
                <input
                  type="number"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              
              {isLoading ? (
  <button type="button" className="cta-button loading" disabled>
    Sending...
  </button>
) : (
  <button type="submit" className="cta-button primary">
    Send Message
  </button>
)}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
//

// Privacy Policy Page Component
export const Privacy = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-header">
          <h1 className="legal-title">Privacy Policy</h1>
          <p className="legal-subtitle">Last updated: January 2026</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>Information We Collect</h2>
            <p>
             Certain visitors to Dermaviosn’s websites choose to interact with Dermaviosn in ways that require the collection of personally‑identifying information. As a dermatology consultancy, we do not request sensitive personal details such as social media account usernames, passwords, or unrelated emails. Our focus is solely on providing professional consultation and solutions for our clients’ dermatological concerns.
             In each case, Dermaviosn collects such information only to the extent necessary or appropriate to fulfill the purpose of the visitor’s interaction — whether that is booking a consultation, purchasing dermatology products, or accessing specialized skincare advice.

Dermaviosn does not disclose personally‑identifying information except as described in this policy. Visitors may always refuse to supply such information, with the understanding that it may prevent them from engaging in certain dermatology‑related website activities, such as booking appointments or accessing personalized treatment recommendations.</p>
          </section>

          <section className="legal-section">
            <h2>How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide, maintain, and improve our services</li>
              <li>Process transactions and send related information</li>
              <li>Send technical notices and support messages</li>
              <li>Communicate with you about products, services, and events</li>
              <li>Monitor and analyze trends and usage</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Information Sharing</h2>
            <p>
              We do not sell, trade, or rent your personal information to third parties. We may share 
              your information only in the following circumstances:
            </p>
            <ul>
              <li>With your consent</li>
              <li>To comply with legal obligations</li>
              <li>To protect our rights and safety</li>
              <li>In connection with business transfers</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Data Security</h2>
            <p>
              We implement appropriate security measures to protect your information against unauthorized 
              access, alteration, disclosure, or destruction. However, no method of transmission over 
              the internet is 100% secure.
            </p>
          </section>
          <section className="legal-section">
            <h2>Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at 
              dermavisiondwarka@gmail.com or through our contact page.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

// Terms and Conditions Page Component
export const Terms = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-header">
          <h1 className="legal-title">Terms and Conditions</h1>
          <p className="legal-subtitle">Last updated: January 2025</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>Acceptance of Terms</h2>
            <p>
             Welcome to Dermaviosn. These Terms and Conditions govern your use of our website and services. By accessing or using our services, you agree to be bound by these terms. ”, meta,or any of its service”.
            </p>
          </section>

          <section className="legal-section">
            <h2>Service Description</h2>
            <p>
              Dermaviosn Skin Profile Audits → Comprehensive analysis of your skin type, condition, and lifestyle factors.

Dermatological Assessments → In‑depth evaluations to identify concerns such as acne, pigmentation, or sensitivity.

Growth Strategies → Personalized treatment and care plans designed to improve skin health and long‑term wellness.

Technical Support → Guidance on dermatology products, therapies, and advanced skin‑care technologies.
            </p>
          </section>
          <section className="legal-section">
            <h2>Service Limitations</h2>
            <p>
             At Dermalogic, we are dedicated to providing exceptional service and care. While we strive to achieve the best possible outcomes, specific results cannot be guaranteed. External factors beyond our control — including changes in industry standards, digital platforms, or third‑party policies — may influence service delivery. Dermalogic is not responsible for actions or circumstances outside our practice that could affect your experience or results.
            </p>
          </section>

          <section className="legal-section">
            <h2>Payment Terms</h2>
            <p>
              Payment for services is due in advance. All fees are non-refundable unless otherwise 
              stated in our refund policy. Prices are subject to change with notice.
              Consultation Appointment Payments for services must be made in advance as per the pricing displayed on our website.
              Dermavsion reserves the right to modify prices at any time.
            </p>
          </section>

          <section className="legal-section">
            <h2>Limitation of Liability</h2>
            <p>
              Dermaviosn shall not be liable for any indirect, incidental, special, consequential, 
              or punitive damages, including without limitation, loss of profits, data, or use.
            </p>
          </section>

          <section className="legal-section">
            <h2>Contact Information</h2>
            <p>
              For any questions regarding these Terms and Conditions, please contact us at 
              dermavisiondwarka@gmail.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

// Refund and Cancellation Policy Page Component
export const Refund = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-header">
          <h1 className="legal-title">Refund and Cancellation Policy</h1>
          <p className="legal-subtitle">Last updated: January 2026</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>Refund Policy</h2>
            <p>
              This Refund and Cancellation Policy outlines the conditions under which users of Dermavsion may be eligible for refunds and the process for cancellations.
            </p>
          </section>

          <section className="legal-section">
            <h2>Consultation Fees</h2>
            <p>At Dermalogic, consultation fees are applied to cover the value of our expert advice and personalized guidance. These fees reflect the time, knowledge, and professional expertise of our consultants in addressing your skincare concerns and providing tailored recommendations.</p>
            <p>These fees are non-refundable under any circumstances, as they cover the time and expertise of our consultants.</p>
            
          </section>

          <section className="legal-section">
            <h2>Refund Eligibility for Services</h2>
            <p>Refunds are only applicable if Dermavsion fails to deliver the promised Guidance or security service as per the agreed scope.</p>
            <p>No refund will be provided if the user fails to follow the instructions provided for consultation.</p>
           
          </section>

          <section className="legal-section">
            <h2>Subscription Plans</h2>
            <p>Users may cancel their subscription plans at any time. However, no refund will be provided for the remaining period of the subscription.</p>
          
          </section>

          <section className="legal-section">
            <h2>Cancellation Process</h2>
            <p>
              Users may cancel any service request before our team begins processing it. Once the service is in progress, no cancellation or refund is allowed.
            </p>
          </section>

          <section className="legal-section">
            <h2>Refund Request Process</h2>
            <p>Users seeking a refund must contact Dermavsion at dermavisiondwarka@gmail.com within seven (7) days of service completion.</p>
            <p>Our team will review the request and provide a response within five (5) business days.</p>
            
          </section>

          <section className="legal-section">
            <h2>Changes to Refund and Cancellation Policy</h2>
            <p>
              Dermavsion reserves the right to modify this Refund and Cancellation Policy at any time. Changes will be notified on our website.
            </p>
          </section>

          <section className="legal-section">
            <h2>Contact Us</h2>
            <p>
              For any questions about refunds or cancellations, please contact us at 
              dermavisiondwarka@gmail.com or through our contact page.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};